<!-- 驼铃杯 -->
<template>
    <div class="cup">
        <div class="top flex-align">
            <img src="../assets/new/cup.png" alt="">
            <div class="text flex-column">
                <span>第一届“驼铃杯”课堂教学大赛</span>
                <p>为践行习近平总书记在内蒙古自治区考察时的重要指示精神，落实《关于深化京蒙教育东西部协作工作的协议》,
                    推动《“京蒙教育协作智慧平台”建设方案》落地，聚焦京蒙教育协作的课堂教学工作，在北京市教委指导下，
                    由我局主办、贵校“双优云桥”承办的“京蒙携手·教育振兴”第一届“驼铃杯”课堂教学大赛，将于7月19日至21
                    日在国家乡村振兴重点帮扶县教育人才“组团式”帮扶学校——商都高级中学举办，以搭建京蒙两地教师交流与展示平台，示范、引领、带动一线教师专业成长。</p>
            </div>
        </div>
        <div class="content">
            <el-tabs v-model="activeName" @tab-click="handleClick">
                <el-tab-pane label="活动首页" name="first">
                    <div class="activityHome">
                        <div class="title flex-align-center">大赛简介</div>
                        <div class="item flex-align">
                            <div class="icon"></div>
                            主题
                        </div>
                        <div class="wrap">“五新”背景下的高中课堂教学实践</div>
                        <div class="item flex-align">
                            <div class="icon"></div>
                            参赛对象
                        </div>
                        <div class="wrap">本次赛课选手主要由受援方内蒙古自治区乌兰察布市 的国家乡村振兴重点帮扶旗县和援助方的北京市平谷区、
                            丰 台区等青年骨干教师组成，涵盖高中语文、数学、英语、物 理、历史五个学科。参赛教师须经学校推荐，由赛事组委会 专家组遴选出80位入围比赛的选手，参加现场课堂教学比赛。
                        </div>
                        <div class="item flex-align">
                            <div class="icon"></div>
                            奖项设置
                        </div>
                        <div class="wrap">每学科获奖比例：一等奖30%、二等奖30%、 三等奖40%。最终将视比赛情况确定最终获奖比例和名单。
                            <div class="danwei">
                                <div class="items">主办单位：乌兰察布市教育局</div>
                                <div class="items">指导单位：北京市教委支援合作处</div>
                                <div class="items">承办单位：北京双优云桥教育科技有限公司</div>
                                <div class="items">协办单位：商都县教育体育局</div>
                                <div class="items">平台支持：“首都教育远程互助工程”首都师范大学“双优云桥”智慧教育平台</div>
                            </div>
                        </div>
                        <div class="title flex-align-center">大赛流程</div>
                        <div class="liucheng flex-align-center">
                            <div class="flex-align">
                                <div class="liuchengItem">
                                    <div class="liuchengContent flex-column">
                                        <span>开幕式</span>
                                        <div class="line"></div>
                                        <div class="time flex-column-center">2023.7.19 上午</div>
                                    </div>
                                </div>
                                <div class="liuchengItem2">
                                    <div class="liuchengContent flex-column">
                                        <span>教学大赛</span>
                                        <div class="line"></div>
                                        <div class="time flex-column-center">2023.7.19 -7.21</div>
                                    </div>
                                </div>
                                <div class="liuchengItem3">
                                    <div class="liuchengContent flex-column">
                                        <span>闭幕式</span>
                                        <div class="line"></div>
                                        <div class="time flex-column-center">2023.7.21</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="title flex-align-center">课程展示</div>
                        <div class="courseBox flex-between">
                            <div class="courseItem flex-column-between" v-for="(item,index) in courseList" :key="index"
                                @click="goLive(item.video)">
                                <img :src="downloadURLImg+item.cover" alt="" v-if="item.cover">
                                <img src="../assets/course/course-cover05.jpg" alt="" v-else>
                                <span class="course_name">{{item.name}}</span>
                                <span class="name">{{item.teacherName}}</span>
                            </div>
                        </div>
                        <div class="more" @click="more">更多</div>
                    </div>
                </el-tab-pane>
                <el-tab-pane label="精彩回顾" name="second">
                    <div class="huigu">
                        <div class="video">
                            <video src="../assets/images/01.mp4" controls></video>
                        </div>
                        <div class="plan">
                            <img src="../assets/cup/table.png" alt="">
                        </div>
                    </div>
                </el-tab-pane>
                <el-tab-pane label="研训成果" name="third">
                    <div class="result">
                        <div class="box" v-for="(item,index) in list" :key="index">
                            <div class="item">
                                <span class="title">{{ item.title }}</span>
                                <div class="introduce">{{ item.introduce }}</div>
                                <div class="tag">
                                    标签
                                    <span>#{{item.mark}}#</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </el-tab-pane>
            </el-tabs>
        </div>
        <Login2 v-if="showLogin" :courseId='courseId'></Login2>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                activeName: 'first',
                courseList: [],
                courseId: null,
                showLogin: false,
                list: [],
                cupInfo: {
                    flowList: []
                }
            }
        },
        methods: {
            handleClick(tab, event) {
                console.log(tab, event);
            },
            goLive(url){
                let query = {
                    url
                }
                this.$router.push({path:'/home/courseDetail2',query})
            },
            // goLive(id) {
            //     this.courseId = id;
            //     window.open(
            //             `https://jm.cnuen.net/login?un=18131405634&pd=Syyq123456@&origin=jm&courseId=${this.courseId}&projectId=266&goPath=course&keyCode=d63becec70f41c0ae20bca40e81f81dc&captchaCode=rgdzf`
            //             //  `http://localhost:8081/login?un=${this.pwdForm.username}&pd=${this.pwdForm.password}&origin=jm&courseId=${this.courseId}&goPath=course&keyCode=d63becec70f41c0ae20bca40e81f81dc&captchaCode=rgdzf`
            //         );
            // },
            getList() {
                let data = {
                    page: 1,
                    limit: 100,
                    matchId: this.cupInfo.id
                };
                Api.Home.Result(data)
                    .then(res => {
                        // console.log('研训成果:', res);
                        this.list = res.data.records
                    })
                    .catch(err => {
                        console.log('err:', err)
                    })
            },
            getCupInfo() {
                Api.Home.cupInfo()
                    .then(res => {
                        // console.log('驼铃杯信息:', res);
                        this.cupInfo = res.data;
                        this.getList();
                        this.getCourseList()
                    })
                    .catch(err => {
                        console.log('err:', err)
                    })
            },
            more(){
                this.$router.push('/home/courseMore')
            },
            getCourseList(){
                let data = {
                    matchId:this.cupInfo.id,
                    page: 1,
                    limit: 3,
                }
                Api.Home.listActivity(data)
                    .then(res=>{
                        console.log('专题活动:',res);
                        this.courseList = res.data.records;
                    })
                    .catch(err=>{
                        console.log('专题活动失败:',err)
                    })
            }
            
        },
        mounted() {
            this.getCupInfo();
            // this.getCourseList()
        },
    };
</script>
<style lang='less' scoped>
    @import url("./less/cup3.less");
</style>